import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { DemoSlotPicker } from '../components/landing-page/LiveChat';

// Public page a lead lands on (from WhatsApp/Aayush) to book a 30-min live demo slot.
export default function BookDemoPage() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const prefill = {
    name: params.get('n') || params.get('name') || '',
    phone: params.get('p') || params.get('phone') || '',
    school: params.get('s') || params.get('school') || '',
    schoolName: params.get('s') || params.get('school') || '',
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-50 via-white to-amber-50 flex flex-col items-center justify-center px-4 py-10" data-testid="book-demo-page">
      <div className="mb-6 text-center">
        <img src="/logo.png" alt="शिक्षा मित्र" className="h-12 mx-auto mb-3" onError={(e) => { e.target.style.display = 'none'; }} />
        <h1 className="text-3xl sm:text-4xl font-extrabold text-gray-900">शिक्षा मित्र — Live Demo Book करें</h1>
        <p className="text-sm text-gray-600 mt-2 max-w-md mx-auto">
          अपनी सुविधा का 30-मिनट का समय चुनें। हमारी team आपको Google Meet पर पूरा platform घुमाकर दिखाएगी — कोई login/credentials नहीं, बस एक live demo. 🙏
        </p>
      </div>
      <DemoSlotPicker
        prefill={prefill}
        sessionId={null}
        onClose={() => navigate('/')}
      />
    </div>
  );
}
